import WebApp from '@twa-dev/sdk';

import { type Intl } from '@/app/lib/localization/hooks/types';

import { PROD_TG_MARKET_LINK } from '@/shared/constants';

import { closeWebapp } from './close-webapp';
import { confirmAction } from './confirm';

export const returnToMarket = async (data?: {
  needAsk: boolean;
  t: Intl;
}): Promise<void> => {
  if (
    data?.needAsk &&
    !(await confirmAction({
      cancel: data.t('Stay'),
      agree: data.t('Leave'),
      message: data.t('Are you sure you want to leave the game?'),
    }))
  ) {
    console.log('user cancelled');
    return;
  }

  // Если в истории есть больше 1-го, то это редирект из маркета
  // Если <=1, то это прямая ссылка и нужно открыть маркет
  // возможно стоит рассмотреть использование document.referrer т.к добавление роутинга во враппер это сломает,
  // но и роутинг по мне лучше не добавлять во враппер (будет провоцировать березагрузку игры, надо игру уносить в outlet)
  if (WebApp) {
    WebApp.unlockOrientation();
  }

  if (window.history.length > 1) {
    history.back();
  } else if (WebApp) {
    WebApp.openTelegramLink(PROD_TG_MARKET_LINK);
    closeWebapp();
  } else {
    window.open(PROD_TG_MARKET_LINK);
  }
};
